import { useDispatch, useSelector } from "react-redux";

import { ContentElementService } from "@/services";

import { ELEMENT_STATUS, ENTITY, TAB_STATUSES } from "../../constants";
import { useEventListeners, useUnload, useUrlParams } from "../../hooks";
import { resetCurrentSelectedItems, resetVisualBuilderData, setVisualBuilderValues } from "../../store/actions";
import { contentElementsSelector, currentMediaItemSelector, elementsSelector } from "../../store/selectors";
import { removeElement } from "../../store/v2/elements/elementsThunks";

export function useVisualBuilderListeners() {
  const dispatch = useDispatch();

  const params = useUrlParams();
  const { propertyId, experienceId, userId, tabStatus } = params;

  const {
    mediaItem: { id: mediaItemId },
  } = useSelector(currentMediaItemSelector);

  const { elements } = useSelector(elementsSelector(propertyId, experienceId));
  const { elements: contentElements } = useSelector(contentElementsSelector(propertyId, mediaItemId));

  let entities = [{ name: ENTITY.EXPERIENCE, options: { propertyId } }];

  if (userId) {
    entities = [...entities, { name: ENTITY.NOTIFICATION, options: {} }];
  }

  if (experienceId) {
    entities.push({ name: ENTITY.EXPERIENCE_MEDIA_ITEM, options: { propertyId, experienceId } });
  }

  useEventListeners({ entities });

  useUnload(() => {
    dispatch(setVisualBuilderValues(propertyId, "prevTabStatus", null));
    if (
      propertyId &&
      [TAB_STATUSES.HOMEBASE, TAB_STATUSES.COLLECT, TAB_STATUSES.CUSTOMIZE, TAB_STATUSES.SHARE].includes(tabStatus)
    ) {
      dispatch(resetVisualBuilderData(params));
    }

    dispatch(resetCurrentSelectedItems());

    const promises = [];
    if (elements.length) {
      elements.forEach((element) => {
        if (element.status === ELEMENT_STATUS.DRAFT) {
          // we don't need to update state because we're already exiting the page
          promises.push(
            dispatch(removeElement({ propertyId, experienceId: element.experienceId, elementId: element.id })),
          );
        }
      });
    }

    if (contentElements.length) {
      contentElements.forEach((element) => {
        if (element.status === ELEMENT_STATUS.DRAFT) {
          // we don't need to update state because we're already exiting the page
          promises.push(ContentElementService.deleteContentElement(propertyId, element.mediaItemId, element.id));
        }
      });
    }

    if (promises.length) {
      Promise.all(promises).then();
    }
  });
}
